export default __webpack_public_path__ + "3096f18acebc3f07020db0efc3721fdf.woff2";